// ABOUTME: Standard storefront events/actions adapter (R4) — makes the shopify:* namespace the
// theme's public integration contract over the jf-cart operator and Horizon's private event bus.
//
// App→theme: Shopify.actions is configured inline in snippets/scripts.liquid (registration must
// win the DOMContentLoaded ordering against app code, so it cannot live in this deferred module).
// updateCart runs eventTarget-only — the injected runtime keeps its Storefront API write, skips
// the page-reload fallback, and auto-emits shopify:cart:* from our elements; this module then
// re-renders the cart surfaces from the auto-emitted event (the runtime no longer reloads for us).
//
// Theme→apps: jf-cart dispatches standard events for every mutation it operates, and core's own
// flows dispatch theirs directly from @shopify/events (product-form adds resolve with
// source 'product-form-component', cart-row mutations with 'cart-items-component'), so no flow
// reaches apps only on the private bus and nothing here bridges one onto the standard namespace.
//
// DATED ADAPTER (2026-07-10): the private surfaces this adapter fronts — @theme/jf-cart-events
// cart:update and jf-cart's window.atc/window.JFCart globals — are compatibility contracts only;
// new integrations must use the standard events/actions.

import { refreshCartSections } from '@theme/jf-cart';

/**
 * Re-renders the cart surfaces after an app/agent calls a configured standard action.
 * A configured updateCart skips the runtime's own page refresh, so the theme owns it:
 * fetch cart + bundled sections and announce on the private bus (core components morph).
 */
const followStandardActionUpdates = () => {
  document.addEventListener('shopify:cart:lines-update', (event) => {
    if (event.context !== 'standard-action') return;
    event.promise?.then(() => refreshCartSections()).catch(() => {});
  });
};

followStandardActionUpdates();
